import { render } from "./ValueTrade.vue?vue&type=template&id=4daf9dfe"
import script from "./ValueTrade.vue?vue&type=script&lang=js"
export * from "./ValueTrade.vue?vue&type=script&lang=js"

import exportComponent from "/Users/anderson/Developer/Landing-Page/iCoin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__